var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',[_c('v-list-item-avatar',[_c('v-icon',{attrs:{"color":"green darken-4"}},[_vm._v(_vm._s(_vm.icone))])],1),_c('v-list-item-content',[_c('v-list-item-title',{staticClass:"body-1 font-weight-bold green--text text--darken-4"},[_vm._v(" "+_vm._s(_vm.titulo)+" ")]),_c('v-list-item-subtitle',[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }